import { useEffect } from "react";
import { routes, useSimpleKitContext } from "./SimpleKitContext";
import { NetworkSymbols } from "based-auth/networks";
import { useSolanaWallet } from "@/react/hooks";
import { chainSol, chainSolDevnet, isMainnet } from "based-auth/chains";
import { useQueryClient } from "@tanstack/react-query";

export function SimpleKit() {
  const { setRouter, setPendingItem } = useSimpleKitContext();
  const { solWallets } = useSolanaWallet();
  const queryClient = useQueryClient();

  // useEffect(() => {
  //   const unwatchWagmiAccount = wagmiWatchAccount(wagmiConfig, {
  //     async onChange(data) {
  //       const { address, chainId, cchain, connector } = data;
  //       console.log("wagmiWatchAccount change", data);
  //       if (!address) {
  //         return;
  //       }
  //       if (!chain) {
  //         const newChain = chains.find(
  //           (c) => c.network.symbol === NetworkSymbols.eth
  //         );
  //         if (!newChain) {
  //           throw new Error("No eth chain found");
  //         }
  //         try {
  //           await wagmiSwitchChain(wagmiConfig, {
  //             connector,
  //             chainId: newChain.id,
  //           });
  //         } catch {
  //           setPendingItem(() => {
  //             setRouter(routes.selectETHWallet);
  //             return null;
  //           });
  //           return;
  //         }
  //       }
  //       setRouter(() => {
  //         setPendingItem({
  //           id: connector?.id,
  //           logo: connector?.icon,
  //           network: NetworkSymbols.eth,
  //           chainId,
  //           address: address,
  //         });
  //         return routes.accountSigning;
  //       });
  //     },
  //   });

  //   ethWallets.forEach((connector) => {
  //     connector.emitter.on("connect", async (connectInfo: any) => {
  //       const { accounts, chainId } = connectInfo;
  //       setRouter(() => {
  //         setPendingItem({
  //           id: connector.id,
  //           logo: connector.icon,
  //           network: NetworkSymbols.eth,
  //           chainId,
  //           address: accounts[0],
  //         });
  //         return routes.accountSigning;
  //       });
  //     });
  //     connector.emitter.on("change", async (changeInfo: any) => {
  //       const { chainId } = changeInfo;
  //       console.log("change", changeInfo, connector.id, connector.name);
  //       if (!chains.find((c) => c.id === chainId)) {
  //         const chain = chains.find(
  //           (c) => c.network.symbol === NetworkSymbols.eth
  //         );
  //         if (!chain) {
  //           throw new Error("No eth chain found");
  //         }
  //         setRouter(() => {
  //           setPendingItem({
  //             name: chain.name,
  //             logo: chain.logo,
  //             args: [chain.id],
  //           });
  //           return routes.switchingChain;
  //         });
  //       }
  //     });
  //     connector.emitter.on("display_uri", (uri: any) => {
  //       console.log("display_uri", uri, connector.id, connector.name);
  //     });
  //     connector.emitter.on("error", (error: any) => {
  //       console.log("error", error, connector.id, connector.name);
  //     });
  //   });
  //   return () => {
  //     unwatchWagmiAccount();
  //   };
  // }, [ethWallets]);

  useEffect(() => {
    solWallets.forEach((connector) => {
      connector.on("connect", async (publicKey) => {
        setRouter(() => {
          setPendingItem({
            id: connector.name,
            logo: connector.icon,
            network: NetworkSymbols.sol,
            chainId: isMainnet ? chainSol.id : chainSolDevnet.id,
            address: publicKey.toBase58(),
          });
          return routes.accountSigning;
        });
      });
      connector.on("error", (error: any) => {
        console.log("error", error, connector.name);
      });
      connector.on("disconnect", async () => {
        console.log("disconnect", connector.name);
      });
    });
    return () => {
      solWallets.forEach((connector) => {
        connector.off("connect");
        connector.off("error");
        connector.off("disconnect");
      });
    };
  }, [solWallets]);

  useEffect(() => {
    queryClient.fetchQuery({
      queryKey: ["use-social-providers"],
    });
  }, []);

  return <></>;
}
